
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import ConsultaTuCuentaForm from "@/components/Consulta_Tu_Cuenta/ConsultaTuCuentaForm.vue";
import ConsultaTuCuentaResult from "@/components/Consulta_Tu_Cuenta/ConsultaTuCuentaResult.vue";
import Swal from "sweetalert2";
import UserResponse from "@/models/WsdlResponses/UserResponse";
import UserBalance from "@/models/WsdlResponses/UserBalance";
import ConsultaAfiliadoFallecido from "../ConsultaAfiliadoFallecido.vue";
import AfiliadoService from "@/services/AfiliadoService";
import EstadoDeCuentaModel from "@/models/TuEstadoCuenta/TuEstadoCuentaModel";
import UmbracoApiService from "@/services/UmbracoApiService";

@Component({
    components: {
        ConsultaTuCuentaForm,
        ConsultaTuCuentaResult,
    },
})
export default class ConsultaTuCuenta extends Vue {
    public userId: string = this.$store.state.user.cedula;
    public showResult: boolean = false;
    public isLoading: boolean = false;
    public fromDate: string = "";
    public toDate: string = "";
    public user: UserResponse = new UserResponse();
    public wsdlService: WsdlService = new WsdlService();
    public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
    public labelData = new EstadoDeCuentaModel();
	public balance: Array<UserBalance> = [];
	public balanceOldDoceMonth: Array<UserBalance> = [];
	public initialAmount: number = 0;
	public finalAmount: number = 0;
    public initialAMountOldDoceMonth = 0;
    public finalAMountOldDoceMonth = 0;
    public umbracoService = new UmbracoApiService();
	//TODO create models
	public movements: any = {};
	public comision: any ={};
	public aportes: any ={};
	public comisiones: any ={};
    public afiliadoServices:AfiliadoService = new AfiliadoService();
    constructor() {
        super();
    }
    public async mounted() {
        await this.getLabelData();
    }

    public async getLabelData() {
    this.labelData = await this.umbracoService.getEstadoDeCuenta();
  }
    public async process(
        fromDate: string,
        toDate: string,
        tipoFondo: FundType
    ) {
        if (fromDate && toDate) {
            this.isLoading = true;
            this.toDate = toDate;
            this.fromDate = fromDate;
            this.getUser(fromDate, toDate, tipoFondo)
                .then(() => {
                    this.showResult = true;
                })
                .catch((ex) => {
                    Swal.fire({
                        text: "¡Lo sentimos! Ha ocurrido un error en la consulta",
                        icon: "error",
                        showConfirmButton: true,
                        confirmButtonText: "Ok",
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        } else {
            Swal.fire({
                text: "Debe seleccionar una fecha de inicio y una fecha final para consultar su cuenta",
                icon: "error",
                showConfirmButton: true,
                confirmButtonText: "Ok",
            });
        }
    }
    public async getUser(
        fromDate: string,
        toDate: string,
        tipoFondo: FundType
    ) {
        await this.getUserData(this.userId);
		await this.GetBalanceDeUsuario(fromDate, toDate, tipoFondo);
        await this.getPreviousYearDate(tipoFondo,toDate);
		await this.getMovimientos(fromDate, toDate, tipoFondo);
		await this.getComision(fromDate, toDate, tipoFondo);
		await this.GetAportesDeUsuario(fromDate, toDate, tipoFondo);
        await this.getComisiones(tipoFondo,toDate);
        
    }
    public async getComisiones(tipoFondo:FundType,toDate: string,){
    var body = {
    canal: "PortalBe",
    codUsuario: this.userId,
    codFondo: tipoFondo.tipofondo,
    codInversion: this.balance[1].codinversion,
    fechaComision: toDate
    }
    const response = await this.afiliadoServices.obtenerComision(body);
    this.comisiones  = response.data;
   
}
	public async GetAportesDeUsuario(fromDate: string,
        toDate: string,
        tipoFondo: FundType){
		this.wsdlService.GetAportesDeUsuario(tipoFondo.tipofondo, tipoFondo.codcuenta, fromDate, toDate).then(resp => {
			this.aportes = resp.data;
		})
	}

    
    public async getPreviousYearDate(tipoFondo: FundType,toDate: string){
            var currentDate = new Date(toDate);
            var currentYear = currentDate.getFullYear();
            var lastYear = currentYear - 1;
            var lastYearDate = new Date(lastYear, currentDate.getMonth(), currentDate.getDate());
            await this.wsdlService
            .GetBalanceDeUsuario(tipoFondo.tipofondo, tipoFondo.codcuenta,this.getFormattedDate(currentDate), this.getFormattedDate(lastYearDate))
            .then((resp: AxiosResponse<Array<UserBalance>>) => {
                this.balanceOldDoceMonth = resp.data;
				this.wsdlService.GetValorCuota(tipoFondo.tipofondo, this.balanceOldDoceMonth[0].codinversion, this.getFormattedDate(currentDate))
				.then((response: AxiosResponse<any>) => {
					let iDate = new Date(response.data.pfechamax);
					let serviceInitialDate = this.getFormattedDate(iDate);
					this.wsdlService.GetValor(tipoFondo.tipofondo, this.balanceOldDoceMonth[0].codinversion, serviceInitialDate).then(resp => {
						this.initialAMountOldDoceMonth = resp.data.valor;
						});
				});
				if(this.balanceOldDoceMonth.length < 2){
					this.finalAMountOldDoceMonth = this.initialAMountOldDoceMonth
					return;
				}
				this.wsdlService.GetValorCuota(tipoFondo.tipofondo, this.balanceOldDoceMonth[1].codinversion, this.getFormattedDate(lastYearDate))
				.then((response: AxiosResponse<any>) => {
					let fDate = new Date(response.data.pfechamax);
					let serviceFinalDate = this.getFormattedDate(fDate);
					this.wsdlService.GetValor(tipoFondo.tipofondo, this.balanceOldDoceMonth[0].codinversion, serviceFinalDate).then(resp => {
						this.finalAMountOldDoceMonth = resp.data.valor;
					});
				});
            });
}

        public restarUnDia(fecha) {
        var nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() - 1);
        return nuevaFecha;
        }
	public async GetBalanceDeUsuario(fromDate: string,
        toDate: string,
        tipoFondo: FundType){
		await this.wsdlService
            .GetBalanceDeUsuario(tipoFondo.tipofondo, tipoFondo.codcuenta, fromDate, toDate)
            .then((resp: AxiosResponse<Array<UserBalance>>) => {
                this.balance = resp.data;
				this.wsdlService.GetValorCuota(tipoFondo.tipofondo, this.balance[0].codinversion, this.getFormattedDate(this.restarUnDia(fromDate)))
				.then((response: AxiosResponse<any>) => {
					let iDate = new Date(response.data.pfechamax);
					let serviceInitialDate = this.getFormattedDate(iDate);
					this.wsdlService.GetValor(tipoFondo.tipofondo, this.balance[0].codinversion, serviceInitialDate).then(resp => {
						this.initialAmount = resp.data.valor;
						});
				});
				if(this.balance.length < 2){
					this.finalAmount = this.initialAmount
					return;
				}
				this.wsdlService.GetValorCuota(tipoFondo.tipofondo, this.balance[1].codinversion, toDate)
				.then((response: AxiosResponse<any>) => {
					let fDate = new Date(response.data.pfechamax);
					let serviceFinalDate = this.getFormattedDate(fDate);
					this.wsdlService.GetValor(tipoFondo.tipofondo, this.balance[0].codinversion, serviceFinalDate).then(resp => {
						this.finalAmount = resp.data.valor;
						});
				});
            });
	}
	public getFormattedDate(date: Date) : string {
		let year = date.getFullYear();

		let month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : '0' + month;

		let day = date.getDate().toString();
		day = day.length > 1 ? day : '0' + day;
		
		return month + '/' + day + '/' + year;
	}
	
	public async getMovimientos(fromDate: string,
        toDate: string,
        tipoFondo: FundType){
		//TODO change hardcoded variable
		await this.wsdlService
            .GetMovimientosDeUsuario(tipoFondo.tipofondo, tipoFondo.codcuenta, fromDate, toDate)
            .then((resp: AxiosResponse<any>) => {
                this.movements = resp.data;
            });
	}
	public async getComision(fromDate: string,
        toDate: string,
        tipoFondo: FundType){
		//12/04/2019
		let splitFromDate = fromDate.split('/');
		let splitToDate = toDate.split('/');
		let formattedFromDate = `${splitFromDate[2]}/${splitFromDate[1]}/${splitFromDate[0]}`;
		let formattedtoDate = `${splitToDate[2]}/${splitToDate[1]}/${splitToDate[0]}`;
		await this.wsdlService
            .getComision(tipoFondo.tipofondo, tipoFondo.codcuenta, formattedFromDate, formattedtoDate)
            .then((resp: AxiosResponse<any>) => {
                this.comision = resp.data;
            });

	}
    public async getUserData(userId: string) {
        await this.wsdlService
            .getUserData(userId)
            .then((resp: AxiosResponse<any>) => {
                this.user = resp.data;
            });
    }

    public returnForm() {
        this.showResult = false;
    }
}
